import { searchTodoLists } from '@erikdakoda/todo/ai-tools/searchTodoLists';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(searchTodoLists);
